import React from 'react';
import withView from '../../../cmn/docAutomation/withView';
import SarasTrans from '../../../../library/notifications/SarasTrans';
import DocSearch from "../../../cmn/docSearch/components/DocSearch";
import FormInput from '../../../../library/form/components/FormInput';
import FormWrapper from '../../../../library/form/components/FormWrapper';


const AlarmCriteria = (props) => {
    const { formObject, viewData } = props;

    if (!viewData)
        return (null)

    /*
        <script language="javascript" type="text/javascript">
    $(function () {
        on_load_cmn_search(1, 1, "#hdAlarmCriteriaReceiver");
    });
</script>
    */

    const onCriteriaChange = (reload, criteriaValue) => {
        // console.log("AlarmCriteria ", reload, criteriaValue)
        let action = { actionId: "refresh", actionParam: { partialupdate: "1", alarmCriteria: criteriaValue } }
        formObject.onFormAction(action, null, null);
    }

    const renderDocSearch = () => {
        if (Object.keys(formObject.childViews).length > 0)
            return (
                <DocSearch viewData={formObject} onSearchByCriteria={onCriteriaChange}
                    enableSearch={false} enableGroups={false} enablefav={false}
                />
            )
        else{
            return(null)
        }
    }

    // console.log("child vieews", formObject.childViews)

    return (
        <div className="uiEditableContent">
            <div className="uiRow">
                <div className="uiROHeader uiSpacer15">
                    <SarasTrans value="Specify Alarm Condition" />
                </div>
                <div className="uiSpacer15">
                    <input id="hdAlarmCriteriaReceiver" className=""  type="hidden" />

                    <FormWrapper customWrapper="div" formObject={formObject} rowKey="" action={{ paramName: "searchCriteriaContainer" }} >
                        {renderDocSearch()}
                    </FormWrapper>

                </div>
                <div className="uiROHeader uiSpacer15">
                    <SarasTrans value="or Specify DB Stored Procedure Name" />
                </div>
                <div className="uiSpacer15">
                    <FormInput formObject={formObject} rowKey="" className="" style={{ maxWidth: "300px", width: "100%" }}
                        action={{ InputType: "input", actionId: "refresh", paramName: "alarmSproc" }}
                    />
                </div>
                <div className="uiROHeader uiSpacer15">
                    <SarasTrans value="or Specify Event Type" />
                </div>
                <div className="uiSpacer15">
                    <FormInput formObject={formObject} rowKey="" className="" style={{ maxWidth: "300px", width: "100%" }}
                        action={{
                            InputType: "ac", actionId: "refresh", paramName: "notifyEventType", acMethod: "NotificationEventType",
                            actionParam: { partialupdate: "1" }
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default withView(AlarmCriteria, "alarmCriteria", "")
